import { IsNotEmpty, Max, Matches, Min } from 'class-validator';
import { IsPositiveInteger } from 'src/models/validators/isPositiveIntegerValidator';

export const DEFAULT_SLA_SECONDS = 86400; // 24 hours in seconds

export default class RoutingGroup {
  @IsNotEmpty()
  id: string;

  @IsNotEmpty()
  @Matches(/\S/, { message: 'The name cannot be empty' })
  name: string;

  @IsPositiveInteger()
  // MAX SLA is 30 days (2592000 seconds ~ 43200 minutes)
  @Max(2592000, { message: 'Your SLA cannot exceed 43200 minutes' })
  @Min(1, { message: 'Enter an SLA greater than 0 min' })
  slaSeconds: number;

  disabled: boolean;
  agentIds: string[];
  defaultEndpoints: string[];
}

export const routingGroupDefault = Object.freeze({
  ...new RoutingGroup(),
  slaSeconds: DEFAULT_SLA_SECONDS,
}) as RoutingGroup;

export class RoutingGroupTableView extends RoutingGroup {
  agentNames: string;
}
